import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'
import { EmptyMessage } from '@core/Areas/FollowMe/Components/Common/EmptyMessage'
import { SkeletonLoader } from './Components/SkeletonLoader'
import { PendingTicket } from './Components/PendingTicket'
import { useSharePendingTicketsData } from './hooks/useSharePendingTicketsData'

export const ShareBetSelection: React.FC<{
  ticketsToShare: Set<number>
  onTicketClick(ticketSeq: number): void
  onEmptyState(): void
}> = ({ onTicketClick, ticketsToShare, onEmptyState }) => {
  const { tickets, isLoading, LoadMoreButton, shouldStopFetching, isEmptyState } =
    useSharePendingTicketsData()

  React.useEffect(() => {
    if (isEmptyState) onEmptyState()
  }, [isEmptyState, onEmptyState])

  if (isEmptyState) {
    return (
      <EmptyMessage
        messageType='tickets'
        title='No Eligible Pending Bets'
        description='Once you place a bet, it’ll show up here - and you’ll be able to share it to Bet Loop.'
      />
    )
  }

  return (
    <WrapperStyled>
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        tickets && (
          <>
            {tickets.map(ticket => (
              <PendingTicket
                key={ticket.ticketSequence}
                ticket={ticket}
                isSelected={ticketsToShare.has(ticket.ticketSequence)}
                onClick={onTicketClick}
              />
            ))}

            {!shouldStopFetching && <LoadMoreButton />}
          </>
        )
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
})
